/**
 * Merge role IDs for the `organizationsAccessRolesCreate` endpoint, which
 * REPLACES the entire `roles[]` array on the member's access record.
 *
 * A UI surface only ever owns a subset of those roles (`managedIds`) — the
 * workspace-roles card owns workspace-scoped custom roles, the app-access tab
 * owns app-scoped roles. To avoid wiping the other surface's grants, preserve
 * every currently-assigned role we DON'T manage, then layer our own selection
 * on top. The two sets are disjoint by construction, but the result is deduped
 * so the contract holds even if that ever stops being true.
 */
export const mergeManagedRoleIds = (
  currentIds: number[],
  managedIds: Set<number>,
  selectedIds: number[]
): number[] => [
  ...new Set([
    ...currentIds.filter((id) => !managedIds.has(id)),
    ...selectedIds
  ])
]
